export function getFormDataObj<T extends object>(formElement: HTMLFormElement) {
  const formData = new FormData(formElement);
  const data: any = {};

  for (let [key, value] of formData.entries()) {
    if (key.indexOf(".") >= 0) {
      const objName = key.substring(0, key.indexOf("."));
      const nestedKey = key.substring(key.indexOf(".") + 1, key.length);
      if (!data[objName]) {
        data[objName] = {};
      }
      data[objName][nestedKey] = value;
    } else {
      data[key] = value;
    }
  }

  return data as T;
}
